import useAvailableBookings from '../api/hooks/useAvailableBookings';
import BookingsList from './BookingsList';
import { useBookingContext } from '../context';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slider from 'react-slick';
import { useEffect, useRef } from 'react';
import { isMobile } from 'react-device-detect';

const settings = {
  infinite: false,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false
};

const SliderComponent = ({ children, sliderRef }) => {
  if (isMobile) {
    return (
        <Slider {...settings} ref={sliderRef} className="m-4 lg:m-10 min-h-[400px]">
          {children}
        </Slider>
    );
  }
  return <div className="flex flex-wrap lg:m-10 justify-center m-2">{children}</div>;
};

export default () => {
  const { selectedDate } = useBookingContext();
  const slider = useRef(null);
  const { data, isFetched } = useAvailableBookings(selectedDate.format('DD-MM-YYYY'));

  useEffect(() => {
    if (isFetched && isMobile) {
      slider.current.slickGoTo(0);
    }
  }, [isFetched]);
  return (
      <SliderComponent sliderRef={slider}>
        {(data || []).map((courtDetails) => (
            <BookingsList courtDetails={courtDetails} key={courtDetails._id} slider={slider.current} />
        ))}
      </SliderComponent>
  );
};
